module.exports = __webpack_public_path__ + "resources/img/img_xcloud_m.f38680abb5624e7f1d577f79c6173ef8.png";